import { useCallback } from 'react';
import { useTranslation as useThirdPartyTranslation } from 'react-i18next';
var translatedKeys = {};
var trackTranslations = function (finalKey, result) { return false; };
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'test') {
    trackTranslations = function (finalKey, result) {
        if (!(translatedKeys[finalKey] && translatedKeys[finalKey] === result)) {
            if (!translatedKeys[finalKey]) {
                translatedKeys[finalKey] = result;
            }
            else {
                translatedKeys["".concat(finalKey, "_").concat(result)] = result;
            }
        }
    };
}
export function useTranslation() {
    // t is the default translation from i18n, using the keyPrefix as a standard
    var t = useThirdPartyTranslation().t;
    var translate = useCallback(function (_a) {
        var id = _a.id, values = _a.values, fallback = _a.fallback;
        if (!id) {
            return '';
        }
        //we need to call twice to resolve dynamic keys
        var resolvedKey = t(id, values);
        var translatedValue = t(resolvedKey, values);
        if (id === resolvedKey || (translatedValue === resolvedKey && !!id.match(/{{.*}}/))) {
            if (fallback) {
                translatedValue = t(fallback, values);
            }
        }
        //this function only have implementation when in testing environment, so we can extract all the keys being used, including the dynamic ones
        //in prod is a empty function
        trackTranslations(id, translatedValue);
        return translatedValue;
    }, [t]);
    return { translate: translate };
}
